import Button from 'components/Button';
import { Dialog } from 'components/Dialog';
import { useCallback, useState } from 'react';
import { ExportDataFileTypeEnum } from 'services/tenantManagementService';
import ExportForm, { ExportModel } from './ExportForm';
import { RadioItemType } from 'components/Form';

export const defaultExportTypeOptions = [
	{ id: ExportDataFileTypeEnum.PDF, text: `i18n.export.pdf` },
	{ id: ExportDataFileTypeEnum.XLSX, text: `i18n.export.xlsx` }
]

type Props = {
	onExport: (exportModel: ExportModel) => void
	loading?: boolean
	exportTypeOptions?: RadioItemType[]
	forceApplyFilters?: boolean
	forceApplySort?: boolean
	forceUseOnlyVisible?: boolean
	forceExportOnlyCurrentPage?: boolean
	hideApplyFilters?: boolean
	hideApplySort?: boolean
	hideUseOnlyVisible?: boolean
	hideExportOnlyCurrentPage?: boolean
}

const ExportToFile = ({
	onExport,
	loading,
	exportTypeOptions,
	forceApplyFilters,
	forceApplySort,
	forceUseOnlyVisible,
	forceExportOnlyCurrentPage,
	hideApplyFilters,
	hideApplySort,
	hideUseOnlyVisible,
	hideExportOnlyCurrentPage,
}: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const exportTypeOptionsMemo =
		!exportTypeOptions || exportTypeOptions.length === 0
			? defaultExportTypeOptions
			: exportTypeOptions;


	const exportCallback = useCallback(
		(exportModel: ExportModel) => {
			onExport(exportModel);
			setIsOpen(false);
		},
		[onExport]
	)

	const cancelCallback = useCallback(
		() => setIsOpen(false),
		[]
	)

	const openModalCallback = useCallback(
		() => setIsOpen(true),
		[]
	)

	return (
		<>
			<Button
				text='i18n.button.export'
				color='secondary'
				onClick={openModalCallback}
				isLoading={loading}
			/>
			<Dialog
				title='i18n.export.toFile'
				onClose={cancelCallback}
				open={isOpen}
			>
				<ExportForm
					save={exportCallback}
					cancel={cancelCallback}
					exportTypeOptions={exportTypeOptionsMemo}
					forceApplyFilters={forceApplyFilters}
					forceApplySort={forceApplySort}
					forceUseOnlyVisible={forceUseOnlyVisible}
					forceExportOnlyCurrentPage={forceExportOnlyCurrentPage}
					hideApplyFilters={hideApplyFilters}
					hideApplySort={hideApplySort}
					hideUseOnlyVisible={hideUseOnlyVisible}
					hideExportOnlyCurrentPage={hideExportOnlyCurrentPage}
				/>
			</Dialog>
		</>
	)
}

export default ExportToFile;
